import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

var PREFIX = "AttachmentsPanel";
var classes = {
    attachmentsBox: "".concat(PREFIX, "-attachmentsBox"),
    attachmentsTitle: "".concat(PREFIX, "-attachmentsTitle"),
    noAttachmentsTitle: "".concat(PREFIX, "-noAttachmentsTitle"),
    attachmentsTitleIcon: "".concat(PREFIX, "-attachmentsTitleIcon"),
    actions: "".concat(PREFIX, "-actions"),
    loading: "".concat(PREFIX, "-loading")
};
var StyledAttachmentsPanel = styled(Box)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {},
        _b["& .".concat(classes.attachmentsBox)] = {
            padding: theme.spacing(1)
        },
        _b["& .".concat(classes.attachmentsTitle)] = {
            display: "flex",
            alignItems: "center",
            marginBottom: theme.spacing(1)
        },
        _b["& .".concat(classes.noAttachmentsTitle)] = {
            display: "flex",
            alignItems: "center"
        },
        _b["& .".concat(classes.attachmentsTitleIcon)] = {
            marginRight: theme.spacing(0.5)
        },
        _b["& .".concat(classes.actions)] = {
            backgroundColor: theme.palette.primary.main,
            textAlign: "right",
            padding: theme.spacing(0.5, 0.5)
        },
        _b["& .".concat(classes.loading)] = {
            color: "black",
            verticalAlign: "middle",
            marginRight: theme.spacing(1)
        },
        _b);
});

export { classes, StyledAttachmentsPanel as default };
//# sourceMappingURL=index.styled.js.map
